import { defineStore } from 'pinia';

import { Api } from '@/Api';
import { useDebug } from '@/composables/useDebug';

const { debug } = useDebug();

export interface LicenseRequest {
  id: string;
  type: string;
  attributes: {
    accepted: boolean;
  };
}

export interface LicenseRequestState {
  list: LicenseRequest[];
  isLoading: boolean;
}

export const useLicenseRequestStore = defineStore('licenseRequestStore', {
  state: () =>
    ({
      list: [],
      isLoading: false,
    }) as LicenseRequestState,
  getters: {
    isPendingRequest: state => !!state.list.find(request => !request.attributes.accepted),
  },
  actions: {
    async load(organizationId: string) {
      try {
        this.isLoading = true;
        const res = await Api.licenseRequest.list(organizationId);
        this.list = res.data?.licenseRequests || [];
        this.isLoading = false;
      } catch (err: any) {
        this.isLoading = false;
        debug(err);
      }
    },
    async addLicenseRequest(organizationId: string) {
      try {
        const res = await Api.licenseRequest.create(organizationId);
        this.list.push(res.data?.licenseRequest);
      } catch (err: any) {
        debug(err);
      }
    },
  },
});
